import script from "./fw36_crawl_articles.vue?vue&type=script&setup=true&lang=js"
export * from "./fw36_crawl_articles.vue?vue&type=script&setup=true&lang=js"

import "./fw36_crawl_articles.vue?vue&type=style&index=0&id=15f63362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15f63362"]])

export default __exports__